import {PostExamsCancel, PostExamsCancelParams, PostExamsCancelModel} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemotePostExamsCancel implements PostExamsCancel {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostExamsCancelModel>,
	) {}

	async post(params: PostExamsCancelParams): Promise<PostExamsCancelModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
